<nav *ngIf="totalPages.length > 1" aria-label="Page navigation example">
  <ul class="pagination justify-content-center">
    <li class="page-item">
      <a
        data-toggle="tooltip"
        data-placement="top"
        title="First Page"
        class="page-link"
        aria-label="First"
        (click)="goToFirstPage()"
      >
        <span aria-hidden="true">&laquo;</span>
        <span class="sr-only">First</span>
      </a>
    </li>
    <li class="page-item">
      <a class="page-link" (click)="goToPreviousPage()">Previous</a>
    </li>
    <li
      *ngFor="let page of totalPages"
      class="page-item"
      [ngClass]="{ active: currentPage === page }"
    >
      <a
        *ngIf="showPaginationNumber(page)"
        class="page-link"
        (click)="goToSpecificPage(page)"
        >{{ page }}</a
      >
    </li>
    <li class="page-item">
      <a class="page-link" (click)="goToNextPage()">Next</a>
    </li>
    <li class="page-item">
      <a
        data-toggle="tooltip"
        data-placement="top"
        title="Last Page"
        class="page-link"
        aria-label="Last"
        (click)="goToLastPage()"
      >
        <span aria-hidden="true">&raquo;</span>
        <span class="sr-only">Last</span>
      </a>
    </li>
  </ul>
</nav>
